<section class="h-100 gradient-form" style="background-color: #eee">
  <div class="container py-5 h-100">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col-xl-10">
        <div class="card rounded-3 text-black">
          <div class="row g-0">
            <div class="col-lg-6">
              <div class="card-body p-md-5 mx-md-4">
                <div class="text-center">
                  <i class="fa fa-address-book fs-100"></i>
                </div>

                <form class="mt-5" [formGroup]="loginForm">
                  <p>Please login to your account</p>

                  <div class="form-outline mb-4">
                    <label class="form-label" for="form2Example11"
                      >Email &nbsp;</label
                    >
                    <p class="emailCondition mb-0">
                      {{ domains?.length > 1 ? "Domains" : "Domain" }} of only
                      <span
                        class="text-bold"
                        *ngFor="let domain of domains; let isLast = last"
                      >
                        {{ domains?.length > 1 && isLast ? "&" : "" }}
                        {{ domain }} {{ !isLast ? "," : "" }}</span
                      >
                      {{ domains?.length > 1 ? "are" : "is" }}
                      allowed to signup.
                    </p>
                    <input
                      type="email"
                      formControlName="email"
                      id="form2Example11"
                      class="form-control"
                      placeholder="Enter a valid Email address"
                    />
                  </div>

                  <div class="form-outline mb-4">
                    <label class="form-label" for="form2Example22"
                      >Password</label
                    >
                    <input
                      type="password"
                      formControlName="password"
                      id="form2Example22"
                      class="form-control"
                      placeholder="Please enter the Password"
                    />
                  </div>

                  <button
                    type="submit"
                    class="btn btn-primary btn-block mt-4 w-100 mb-5"
                    [disabled]="!loginForm.valid"
                    (click)="login()"
                  >
                    Log In
                  </button>

                  <div
                    class="d-flex align-items-center justify-content-center pb-4"
                  >
                    <p class="mb-0 me-2">Don't have an account?</p>
                    <button
                      type="button"
                      class="btn btn-outline-danger"
                      [routerLink]="'/signup'"
                    >
                      Sign up
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div class="col-lg-6 d-flex align-items-center gradient-custom">
              <div class="px-3 py-4 p-md-5 mx-md-4">
                <h4 class="mb-4">Contact Manager</h4>
                <p class="small mb-0">
                  Welcome to Contact manager, here you can create the contacts,
                  Groups and also manage them. Hope you'll enjoy our product.
                  <br/>
                  <br/>
                  Our app enables users to easily store and find contact
                  information, such as names, email, and telephone numbers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
